import { ITexturedShapeDrawableObject, instanceOfITexturedShapeDrawableObject } from "./ITexturedShapeDrawableObject";

export interface IBoxLineObject extends ITexturedShapeDrawableObject {}

export function instanceOfIBoxLineObject(instance: any): instance is IBoxLineObject {
  return instanceOfITexturedShapeDrawableObject<IBoxLineObject>(instance, "boxline");
}
